import React from "react";

const Whishlist = ({ style, pathStyle = {} }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28.568"
      height="25.173"
      style={style}
      viewBox="0 0 28.568 25.173"
    >
      <path
        id="Tracciato_326"
        data-name="Tracciato 326"
        d="M26.069,5.047a6.991,6.991,0,0,0-9.886,0l0,0L14.833,6.394,13.485,5.047A6.992,6.992,0,0,0,3.6,14.936l1.347,1.347,9.889,9.889,9.889-9.889,1.347-1.347a6.991,6.991,0,0,0,0-9.886Z"
        transform="translate(-0.549 -1.998)"
        fill="none"
        stroke="#000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        style={pathStyle}
      />
    </svg>
  );
};
export default Whishlist;
